<template>
  <a
    v-if="newtab"
    :href="url"
    class="menu-item tw:no-underline!"
    :target="'_blank'">
    <IconGoogle :name="icon" />
    <span v-show="!collapsed" class="menu-item-label">{{ label }}</span>
  </a>
  <router-link
    v-else
    :to="{ name: 'custom_link', params: { index } }"
    class="menu-item tw:no-underline!"
    active-class="menu-item--active">
    <IconGoogle :name="icon" />
    <span v-show="!collapsed" class="menu-item-label">{{ label }}</span>
  </router-link>
</template>
<script lang="ts" setup>
const _props = defineProps<{
  index: number
  icon: string
  label: string
  url: string
  newtab: boolean
  collapsed?: boolean
}>()
</script>
<style lang="scss" scoped>

.menu-item {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  width: 100%;
  padding: 0.625rem 0.5rem;
  border-radius: 8px;
  color: var(--fontcolor);
  align-items: center;
  gap: 1rem;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  transition: color 0.2s ease, background-color 0.2s ease;
  white-space: nowrap;
  overflow: hidden;

  :deep(svg) {
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
  }

  &:hover {
    background-color: var(--box-background-color);
  }
}

</style>
